import { Component, Input, OnInit } from '@angular/core';

import { Location } from './../gis/model/google-maps-geocode-result.interface';
import { IEndereco } from '../endereco.interface';


@Component({
  selector: 'app-endereco-mensagens-de-aviso',
  templateUrl: './endereco-mensagens-de-aviso.component.html',
  styleUrls: ['./endereco-mensagens-de-aviso.component.css']
})
export class EnderecoMensagensDeAvisoComponent implements OnInit {

  @Input() f: any = null;
  @Input() endereco: IEndereco = null;
  @Input() novaLocalizacao: Location = null;

  constructor() { }

  ngOnInit(): void {
  }

  _x(): any {
    if ( this.endereco &&
      this.endereco.geom &&
      this.endereco.geom.coordinates &&
      this.endereco.geom.coordinates.lat &&
      this.novaLocalizacao &&
      this.novaLocalizacao.lat ) {
        return Math.abs(Number(this.endereco.geom.coordinates.lat) - Number(this.novaLocalizacao.lat));
      }

    return 0;
  }

  _y(): any {
    if ( this.endereco &&
      this.endereco.geom &&
      this.endereco.geom.coordinates &&
      this.endereco.geom.coordinates.lng &&
      this.novaLocalizacao &&
      this.novaLocalizacao.lng ) {
        return Math.abs(Number(this.endereco.geom.coordinates.lng) - Number(this.novaLocalizacao.lng));
      }

    return 0;
  }

  coordenadaAlterada(): boolean {
    if ( this.endereco &&
         this.endereco.geom &&
         this.endereco.geom.coordinates &&
         this.endereco.geom.coordinates.lat &&
         this.novaLocalizacao &&
         this.novaLocalizacao.lat ) {

          if (
               ( Math.abs(Number(this.endereco.geom.coordinates.lat) - Number(this.novaLocalizacao.lat))
                  +
                 Math.abs(Number(this.endereco.geom.coordinates.lng) - Number(this.novaLocalizacao.lng))
               ) > 0.0001
           ) {
            return true;
          }
    }

    return false;
  }

}
